/**
 * Returns the keys of an object with proper typing.
 * 
 * This utility function provides a type-safe alternative to Object.keys(),
 * which always returns string[] for type safety reasons. This function
 * preserves the actual key types of the object.
 * 
 * @template T - The type of the object, must extend Record<string, unknown>
 * @param obj - The object to get keys from
 * @returns Array of keys with proper typing (keyof T)
 * 
 * @example
 * ```typescript
 * const config = { en: 'English', ru: 'Russian' } as const;
 * const keys = getTypedKeys(config); // Type: ('en' | 'ru')[]
 * ```
 */
export const getTypedKeysFromObject = <T extends Record<string, unknown>>(obj: T): Array<keyof T> => {
    return Object.keys(obj) as Array<keyof T>;
};
